import React from 'react';

class InputTuKhoa extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: this.props.value,
      className: this.props.className
    }
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    })
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
      className: nextProps.className
    })
  }

  handleFocus(e) {
    e.target.select();
  }

  render() {
    return (
      <div className={this.state.className}>
        <label className="ip-label">{this.props.label}</label>
        <input onFocus={this.handleFocus.bind(this)} value={this.state.value} type="text" name="searchKey" placeholder={ this.props.placeholder } className="search-input" onChange={ this.onChange.bind(this) } />
      </div>
      );
  }
}

InputTuKhoa.defaultProps = {
  value: '',
  label: 'Từ khoá',
  placeholder: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function() {
    console.log('Please assign onChange function');
  },
  className: 'input-group-show'
}

export default InputTuKhoa;



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/InputTuKhoa.jsx